import { Component, Input } from '@angular/core';

@Component({
  selector: 'em-warning-icon',
  templateUrl: './warning-icon.component.html',
  standalone: false,
})
export class WarningIconComponent {
  @Input() public text?: string;

  @Input() public iconSize = '14px';
}
